import { getGtmDataLayer } from '@airasia-common/libraries/factories/Analytics';
import { SORT_TYPE, EVENT_TYPE } from '@airasia-common/libraries/constants';
import { GA_CATEGORIES, GA_ACTIONS } from '../../constants';
import { types } from './filter.meta';

const SORT_VALUES = {
  [SORT_TYPE.RECOMMENDED]: 'Recommendation',
  [SORT_TYPE.PRICE_LOW_TO_HIGH]: 'Price Low to High',
  [SORT_TYPE.PRICE_HIGH_TO_LOW]: 'Price High to Low',
  [SORT_TYPE.USER_RATING]: 'User Rating',
};

const getValue = (type, value) =>
  type === EVENT_TYPE.SORT ? SORT_VALUES[value] : value;

const getFilterDataLayer = label =>
  getGtmDataLayer('trackEventNoEcommerce', 'heatmap', 'click', label);

const trackClickOnPriceFilter = (startPrice, endPrice, currency) => {
  let range = endPrice
    ? `${currency} ${startPrice} - ${currency} ${endPrice}`
    : `>${startPrice}`;
  return getGtmDataLayer(
    'trackEventNoEcommerce',
    GA_CATEGORIES.hotelSelectHeatmap,
    GA_ACTIONS.click,
    `Price Filter| ${range}`
  );
};

const trackApplyFilter = ({ event, params }) => {
  return {
    event,
    type: 'firebase',
    param: params,
  };
};

export default {
  [types.UPDATE_HOTEL_FILTER_ANALYTIC_EVENT]: ({ payload: { type, value } }) =>
    getFilterDataLayer(`hotel ${type} | ${getValue(type, value)}`),
  [types.UPDATE_FLIGHT_HOTEL_FILTER_ANALYTIC_EVENT]: ({
    payload: { category, type, value },
  }) =>
    getFilterDataLayer(`snap - ${category} ${type} | ${getValue(type, value)}`),
  [types.CLICK_PRICE_FILTER]: ({
    payload: { startPrice, endPrice, currency },
  }) => trackClickOnPriceFilter(startPrice, endPrice, currency),
  [types.TRACK_APPLY_FILTER]: ({ payload: { event, params } }) =>
    trackApplyFilter({ event, params }),
};
